import { Component, EventEmitter, Output, output } from '@angular/core';
import { MenusComponent } from '../menus/menus.component';
import { LogoutComponent } from '../logout/logout.component';
import { Router, RouterLink } from '@angular/router';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [MenusComponent,LogoutComponent,RouterLink],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss'
})
export class HeaderComponent {


  @Output() selectedMenuItem = new EventEmitter<string>();
  onNavigation(selectedmenu: string) {
    this.selectedMenuItem.emit(selectedmenu);
    console.log('Selected Menu header:', selectedmenu);
  }
}
